import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor } from '@freelancer/ui/icon';
import {
  LinkColor,
  LinkIconPosition,
  LinkUnderline,
  LinkWeight,
} from '@freelancer/ui/link';
import {
  FontColor,
  FontWeight,
  TextAlign,
  TextSize,
} from '@freelancer/ui/text';

@Component({
  selector: 'app-navigation-menu-card',
  template: `
    <fl-link
      class="Container"
      [flTrackingLabel]="trackingLabel"
      [underline]="LinkUnderline.NEVER"
      [link]="url"
      [newTab]="false"
    >
      <div class="PictureContainer">
        <fl-picture
          class="Picture"
          [borderRadiusTop]="true"
          [src]="imgSrc"
          [aspectRatioValue]="'rectangle-small'"
        ></fl-picture>
      </div>
      <div
        class="Info"
        [class.LongDescription]="longDescription"
        [class.IsLoggedOut]="isLoggedOut"
      >
        <fl-text
          [maxLines]="2"
          [color]="descriptionColor"
          [size]="TextSize.XXSMALL"
          [sizeDesktopXLarge]="TextSize.XSMALL"
          [weight]="descriptionWeight"
          [textAlign]="longDescription ? TextAlign.LEFT : TextAlign.CENTER"
        >
          {{ description }}
        </fl-text>

        <fl-text
          *ngIf="!!subDescription"
          [maxLines]="2"
          [color]="descriptionColor"
          [size]="TextSize.SMALL"
        >
          {{ subDescription }}
        </fl-text>

        <fl-link
          *ngIf="readMore"
          flTrackingLabel="MenuCardClick"
          i18n="Read more link"
          class="ViewMoreColor"
          [size]="TextSize.SMALL"
          [iconName]="'ui-chevron-right'"
          [iconPosition]="LinkIconPosition.RIGHT"
          [weight]="LinkWeight.MEDIUM"
          [color]="LinkColor.INHERIT"
          [iconColor]="IconColor.INHERIT"
          [iconAnimation]="true"
        >
          Find out more
        </fl-link>
      </div>
    </fl-link>
  `,
  styleUrls: ['./navigation-menu-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationMenuCardComponent {
  FontWeight = FontWeight;
  FontColor = FontColor;
  IconColor = IconColor;
  LinkIconPosition = LinkIconPosition;
  LinkUnderline = LinkUnderline;
  LinkWeight = LinkWeight;
  TextAlign = TextAlign;
  TextSize = TextSize;
  LinkColor = LinkColor;

  @Input() descriptionColor = FontColor.LIGHT;
  @Input() descriptionWeight = FontWeight.MEDIUM;
  @Input() url: string;
  @Input() imgSrc: string;
  @Input() description: string;
  @Input() subDescription: string;
  @Input() trackingLabel = 'MenuCardClick';
  @Input() readMore = false;
  @Input() longDescription = false;
  @Input() isLoggedOut = false;
}
